@if (form) {
    <div [formGroup]="form">
        <sirius-select
            [placeholder]="placeholder"
            [label]="label"
            [id]="id"
            [options]="options"
            [formControlName]="name"
            [name]="name"
            [identifier]="identifier"></sirius-select>
    </div>
}
